import { useEffect, useRef, useState } from 'react'
import { isValidDate } from '../utils'
import dayjs from 'dayjs'
import { padDigits } from '../../../utils/datetimeFormatUtils'

const useCountdown = (
  date: Date,
): {
  hours: string
  minutes: string
  seconds: string
  loading: boolean
  isOverdue: boolean
} => {
  const [countdown, setCountdown] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(true)
  const [isOverdue, setIsOverdue] = useState<boolean>(false)
  const intervalId = useRef<NodeJS.Timeout>(null)

  const stopInterval = () => {
    if (intervalId.current) {
      clearInterval(intervalId.current)
    }
  }

  useEffect(() => {
    stopInterval()

    if (!isValidDate(date)) {
      setIsOverdue(true)
      setLoading(false)
      return
    }

    const updateCountdown = () => {
      const now = dayjs()
      const targetDate = dayjs(date)
      const diff = targetDate.diff(now)

      if (diff <= 0) {
        setIsOverdue(true)
        setCountdown(0)
        setLoading(false)
        stopInterval()
      } else {
        setCountdown(diff)
        setLoading(false)
      }
    }

    updateCountdown()

    intervalId.current = setInterval(updateCountdown, 1000)
    return () => stopInterval()
  }, [date])

  const hours = padDigits(Math.floor(dayjs.duration(countdown).asHours()))
  const minutes = padDigits(dayjs.duration(countdown).minutes())
  const seconds = padDigits(dayjs.duration(countdown).seconds())

  return {
    hours,
    minutes,
    seconds,
    loading,
    isOverdue,
  }
}

export default useCountdown
